import React from "react";

const ConferenceErrorDiv = (props) => {
  const { message } = props;
  return (
    <div className="closed-conference-block">
      <div className="closed-conference-block-section">
        <h2 className="color-brand">{message}</h2>
      </div>
    </div>
  );
};

export default ConferenceErrorDiv;
